/**
 *
 */
export default class GraphState {

    /**
     * makes a new graph state controller given a graph controller
     * @param {GraphController} graphController
     */
    constructor(graphController) {
        this.graphController = graphController;

        this._state = GraphState.STATES.START;
    }


    /**
     * returns all the possible states of the controller
     * this is used to check what action is currently being performed;
     * accessed using GraphState.STATES.NONE, GraphState.STATES.START, etc
     * NONE: 0,
     * START: 1,
     * TYPING: 2,
     * DROPPING: 3,
     * CROPPING: 4,
     * HIGHLIGHTING: 5,
     * LINKING: 6,
     * CONNECTING: 7,
     * ADDING: 8,
     * EDITING: 9,
     * FOCUSING: 10,
     * INTERPOLATING: 11,
     * DELETING: 12,
     * SAVING: 13
     *
     * @return {Object}
     */
    static get STATES() {
        return {
            NONE: 0,
            START: 1,
            TYPING: 2,
            DROPPING: 3,
            CROPPING: 4,
            HIGHLIGHTING: 5,
            LINKING: 6,
            CONNECTING: 7,
            ADDING: 8,
            EDITING: 9,
            FOCUSING: 10,
            INTERPOLATING: 11,
            DELETING: 12,
            SAVING: 13,
            CASTING: 14,
            LAUNCHHOVERING: 15
        }
    }

    /**
     * sets the state of this controller
     *
     * @param {number} newState the new state to set this controller to. 0-12
     */
    setState(newState) {
        this._state = newState;
        this.graphController.view.div.attr('class', this.get().toLowerCase());
    }

    /**
     * set the state given a valid state name
     * @param {string} stateName one of 'none', 'start', 'typing', ...
     */
    set(stateName) {
        const newState = GraphState.STATES[stateName.toUpperCase()];
        if (_.isNumber(newState)) {
            this.setState(newState);
        } else {
            throw Error('invalid state name');
        }
    }

    /**
     * gets the state of this controller
     * @return {Number} the state of this controller
     */
    getState() {
        return this._state;
    }

    /**
     * gets the name of the current state
     * @return {String}
     */
    get() {
        return Object.keys(GraphState.STATES)[this._state];
    }

    /**
     * checks if the current state name is equal to the given state name
     * @param {string} someStateName
     * @return {Boolean}
     */
    is(someStateName) {
        return this.get() === someStateName.toUpperCase();
    }

    /**
     * checks if the current state name is NOT equal to the given state name
     * @param {string} someStateName
     * @return {Boolean}
     */
    isNot(someStateName) {
        return !this.is(someStateName);
    }


    /**
     * toggles between the given state and the default state
     * @param {Number} state
     */
    toggleState(state) {
        this.setState(this._state === state ? GraphState.STATES.NONE : state);
    }


    /**
     * toggles the state given a valid state name
     * @param {String} stateName
     */
    toggle(stateName) {
        if (Object.keys(GraphState.STATES).includes(stateName.toUpperCase())) {
            this.set(this.get() === stateName.toUpperCase() ? 'none' : stateName.toUpperCase());
        } else {
            throw Error('invalid state name');
        }
    }
}
